import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
export var FlyoutContainer = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: transparent;\n    isolation: isolate;\n"])));
//# sourceMappingURL=FlyoutContainer.js.map